<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body style="background:#fff;padding:17px;">
      <div class="item-box">
        <div class="item-box-title">
          投资者选择想要购买的产品，输入预约金额，对投资者信息、风险承受能力、经办人授权函（如有）、
          投资者主体（如有）进行确认，并同意采用以上信息进行数字证书申请。 <br/>
           <span>界面提示有3秒的强阅读时间，防止投资者误点出错。</span>
        </div>
        <div class="item-box-slide">
          <cube-slide
            :initialIndex="slideNorIndex"
            :showDots="false"
            :autoPlay="false"
            @change="slideNorChange">
            <cube-slide-item>
              <img src="~@/assets/invite1.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/invite2.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div @click="$_jumpSlideItemNor(slideNorIndex)" style="color:#222;" >
              <i class="cubeic-back"></i>
            </div>
            <div class="item-box-slide-desc-n">
              <span>{{`0${slideNorIndex + 1}`}}</span>/02
            </div>
            <div class="item-box-slide-desc-text">{{['填写并确认信息', '三秒强制阅读'][slideNorIndex]}}</div>
            <div @click="$_jumpSlideItemNor(slideNorIndex)" style="color:#222;">
              <i class="cubeic-arrow"></i>
            </div>
          </div>
        </div>
      </div>

    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slideNorIndex: 0,
    };
  },
  methods: {
    slideNorChange(index) {
      this.slideNorIndex = index;
    },
    $_jumpSlideItemNor(index) {
      this.slideNorIndex = index === 0 ? 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-box {
  margin-bottom: 30px;
  .item-box-title {
    font-size: 13px;
    color: #666666;
    line-height: 18px;
    span {
      color: #FF9800;
    }
  }
  .item-box-slide {
    margin: 10px 0;
    border: 1px solid #eee;
    .item-box-slide-desc {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 10px 0;
      color: #999;
      .item-box-slide-desc-n > span {
        color: #2E6BE6;
      }
      .item-box-slide-desc-text {
        flex: .6;
        font-size: 15px;
      }
    }
  }
}
</style>
